/* eslint-disable react/no-did-update-set-state */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import TopBar from '../components/topbar';
import Home from './home/Home';
import Homes from './home/Homes';
import Auth from '../utils/Auth';
import PrivateRoute from '../components/privateRoute/privateRoute';
import ProfileLayout from './ProfileLayout';
import Maintenance from './Maintenance/List/MaintenanceList';
import MaintenanceCreate from './Maintenance/create/MaintenanceCreate';
import MaintenanceDetail from './Maintenance/Detail/MaintenanceDetail';
import InvoiceList from './invoices/InvoiceList';
import InvoiceDetails from './invoices/Detail/InvoiceDetails';
import InvoicePayment from './invoices/Payment/InvoicePayment';
import DocumentList from './Documents/DocumentList';
import { fetchUserProfile, checkSomeModulesPermission } from './authentication/redux/actions';
import ApplicationForm from './Badging/Create/ApplicationForm';
import BadgeList from './Badging/List/BadgeList';
import ApplicationDetail from './Badging/Detail/ApplicationDetail';
import SubscriptionLayout from './subscription/SubscriptionLayout';
import InitiateApplication from './Badging/Create/InitiateApplication';
import GateList from './gate-management/List';
import PlanDataUpdate from './gate-management/PlanDataUpdate';
import TrainingList from './Trainings/List/TrainingList';
import TrainingDetail from './Trainings/Detail/TrainingDetail';
import SmsSafetyPromotions from './SafetyPromotions/SmsSafetyPromotions';
import SelectApplication from './Badging/Create/SelectApplication';
import SignatoryApplication from './Badging/Create/SignatoryApplication/SignatoryApplication';
import FormsList from './forms/List/FormsList';
import CompleteForm from './forms/completeForm/CompleteForm';
import { MYFORMS, DOCUMENTS, INSPECTIONS } from '../constants/RouterConstants';
import MyformDetails from './forms/Details/MyformDetails';
import Editform from './forms/completeForm/Editform';
import DuplicateForm from './forms/completeForm/DuplicateForm';
import Document from './My Documents/Document';
import SSDashboardEmbed from './reports/SSDashboardEmbed';
import TenantNotFound from '../components/noData/TenantNotFound';
import InspectionList from './inspections/List/InspectionList';
import CompleteInspection from './inspections/complete/CompleteInspection';
import MyInspectionDetails from './inspections/Details/MyInspectionDetails';
import AdpLayout from './PermitManagement/ADP/AdpLayout';
import AvpLayout from './PermitManagement/AVP/AvpLayout';
import GrossRecieptList from './GrossReciepts/List/GrossRecieptList';
import GrossRecieptsSubmission from './GrossReciepts/Create/GrossRecieptsSubmission';
import GrossRecieptDetails from './GrossReciepts/Details/GrossRecieptDetails';
import RequestList from './gate-management/GateChangeRequestForm/RequestList';
import RequestLogCreate from './gate-management/GateChangeRequestForm/Create/RequestLogCreate';
import RequestDetail from './gate-management/GateChangeRequestForm/RequestDetail';
import ScormTrainingContent from './Trainings/Detail/ScormTrainingContent';
import ChangePassword from './authentication/components/ChangePassword';
import GateAllocation from './gate-management/GateAllocation/GateAllocation';
import ProfileEdit from '../components/topbar/profile/Edit/ProfileEdit';
import MyTasks from './tasks/MyTasks';
import TaskDetailPage from './tasks/components/TaskDetailPage';

class MainLayout extends Component {
  state = {
    first: true
  }

  componentDidMount() {
    const { actionFetchProfile } = this.props;
    actionFetchProfile();
  }

  componentDidUpdate() {
    const { actionCheckModulePermission, profile, someModulePermission } = this.props;
    const { first } = this.state;
    if (profile?.language && localStorage.getItem('lang') !== profile.language) {
      localStorage.setItem('lang', profile.language);
      window.location.reload();
    }
    if (profile?.airport_permissions?.modules && profile?.id && !someModulePermission && first) {
      actionCheckModulePermission(profile?.airport_permissions?.modules);
      this.setState({ first: false });
    }
  }

  render() {
    const { isMaintenanceEnabled, invoiceEnabled, documentEnabled, profile, trainingEnabled, smsSafetyPromEnabled,
      someModulePermission, isInspectionsEnabled, isMyFormsEnabled, isSharedDcosEnabled, leaseDocumentPermission,
      avpModulePermission } = this.props;
    const isAuthenticated = Auth.getInstance().isAuthenticated();
    const handleMyforms = isMyFormsEnabled;
    const handleMyInspections = isInspectionsEnabled;
    const handleDocuments = isSharedDcosEnabled;
    const hasAirports = localStorage.getItem('portal_airports_access');
    return (
      <>
        { isAuthenticated === true && profile?.tenant?.length > 0 && (
          <>
            <TopBar />
            <PrivateRoute path="/badging/create" component={ApplicationForm} />
            <PrivateRoute exact path="/" component={Home} />
            <PrivateRoute exact path="/v2" component={Homes} />
            <PrivateRoute exact path="/my_tasks" component={MyTasks} />
            <PrivateRoute exact path="/completed_tasks" component={MyTasks} />
            <PrivateRoute exact path="/my_tasks/:id/detail" component={TaskDetailPage} />
            <PrivateRoute exact path="/completed_tasks/:id/detail" component={TaskDetailPage} />
            <PrivateRoute exact path="/reports/_/:dashUri" component={SSDashboardEmbed} />
            { isMaintenanceEnabled !== undefined && isMaintenanceEnabled === true
            && <>
              <PrivateRoute exact path="/maintenance" component={Maintenance} />
              <PrivateRoute exact path="/maintenance/start" component={MaintenanceCreate} />
              <PrivateRoute exact path="/maintenance/:id/detail" component={MaintenanceDetail} />
               </>
            }
            {documentEnabled && documentEnabled === true && (leaseDocumentPermission || avpModulePermission) && (
              <>
                <PrivateRoute exact path="/document" component={DocumentList} />
              </>
            )}
            {invoiceEnabled && invoiceEnabled === true
              && <>
                <PrivateRoute exact path="/invoice" component={InvoiceList} />
                <PrivateRoute exact path="/invoice/:id/detail" component={InvoiceDetails} />
                <PrivateRoute exact path="/invoice/:id/pay" component={InvoicePayment} />
                 </>
            }
            { (profile.permissions?.gate_management?.length > 0) && someModulePermission?.gateEnabled && (
              <>
                <PrivateRoute exact path={['/gateManagement', '/gateManagement/gantt_view']} component={GateList} />
                <PrivateRoute exact path="/gateManagement/:id/edit" component={PlanDataUpdate} />
                <PrivateRoute exact path="/gate_change" component={RequestList} />
                <PrivateRoute exact path="/gate_change/new" component={RequestLogCreate} />
                <PrivateRoute exact path="/gate_change/:id/detail" component={RequestDetail} />
                <PrivateRoute exact path="/gate_allocation" component={GateAllocation} />
              </>
            )}
            {isAuthenticated === true && profile.portal_login_with === 'email' && (
              <PrivateRoute exact path="/changePassword" component={ChangePassword} />
            )}
            <PrivateRoute exact path="/subscription" component={SubscriptionLayout} />
            <PrivateRoute exact path="/profile" component={ProfileLayout} />
            <PrivateRoute exact path="/profile/edit" component={ProfileEdit} />
            { profile?.permissions?.signitory_review && someModulePermission?.badgeEnabled &&(
              <>
                <PrivateRoute exact path="/badging/List" component={BadgeList} />
                 <PrivateRoute exact path="/badging/:id/detail" component={ApplicationDetail} />
                <PrivateRoute exact path="/badging/new" component={InitiateApplication} />
                <PrivateRoute exact path="/badging/:id/edit_initiate" component={InitiateApplication} />
                <PrivateRoute exact path="/badging/select" component={SelectApplication} />
                <PrivateRoute exact path="/badging/form" component={SignatoryApplication} />
                <PrivateRoute exact path="/badging/:id/reapply" component={SignatoryApplication} />
                <PrivateRoute exact path="/badging/:id/renew" component={SignatoryApplication} />
              </>
            )}
            { trainingEnabled && trainingEnabled === true && (
              <>
                <PrivateRoute exact path="/training" component={TrainingList} />
                <PrivateRoute exact path="/training/section/start/:trainingId/:id/:subId" component={TrainingDetail} />
                <PrivateRoute exact path="/training/section/start/:trainingId" component={ScormTrainingContent} />
              </>
            )}
              { (((profile.permissions?.driver_permit?.length > 0) && someModulePermission?.permitEnabled)
              || (profile.permissions?.airfield_worker_driver_permit !== undefined))&& (
                <>
                  <PrivateRoute path="/adp" component={AdpLayout} />
                </>
              )}
              { (profile.permissions?.vehicle_permit?.length > 0) && someModulePermission?.permitEnabled &&(
                <>
                  <PrivateRoute path="/avp" component={AvpLayout} />
                </>
              )}
              {smsSafetyPromEnabled
                && <>
                  <PrivateRoute exact path="/sms/safety_promotion" component={SmsSafetyPromotions} />
                   </>
              }
              {handleMyforms
                && <>
                  <PrivateRoute exact path={MYFORMS} component={FormsList} />
                  <PrivateRoute exact path={'/form-approvals'} component={FormsList} />
                  <PrivateRoute exact path={'/form-submissions'} component={FormsList} />
                  <PrivateRoute exact path={`${MYFORMS}/:id/complete`} component={CompleteForm} />
                  <PrivateRoute exact path={`${MYFORMS}/:id/detail`} component={MyformDetails} />
                  <PrivateRoute exact path={`${MYFORMS}/:id/edit_form`} component={Editform} />
                  <PrivateRoute exact path={`${MYFORMS}/:id/duplicate`} component={DuplicateForm} />
                   </>
              }
              {handleMyInspections
                && <>
                  <PrivateRoute exact path={INSPECTIONS} component={InspectionList} />
                  <PrivateRoute exact path={`${INSPECTIONS}/:id/complete`} component={CompleteInspection} />
                  <PrivateRoute exact path={`${INSPECTIONS}/:id/detail`} component={MyInspectionDetails} />
                  <PrivateRoute exact path={`${INSPECTIONS}/hangar/:id/detail`} component={MyInspectionDetails} />
                  <PrivateRoute exact path={`${INSPECTIONS}/:id/edit_form`} component={Editform} />
                   </>
              }
              {handleDocuments
                && <>
                  <PrivateRoute exact path={`${DOCUMENTS}/:id?`} component={Document} />
                   </>
              }
              {isAuthenticated === true && profile?.permissions?.enable_gross_receipts
                && <>
              <PrivateRoute exact path="/gross_receipts/list" component={GrossRecieptList} />
              <PrivateRoute exact path="/gross_receipts/start" component={GrossRecieptsSubmission} />
              <PrivateRoute exact path="/gross_receipts/:id/detail" component={GrossRecieptDetails} />
              <PrivateRoute exact path="/gross_receipts/:id/edit" component={GrossRecieptsSubmission} />
                   </>
              }
          </>
        )
        }

        {/* when tenant is not found the following code will be executed */}

        { isAuthenticated === true && !profile?.tenant?.length
          &&<>
              <TopBar />
              {!Number(hasAirports) && <TenantNotFound /> }
            </>
        }
      </>
    );
  }
}

const mapStateToProps = state => ({
  profile: state.auth.profile,
  someModulePermission: state.auth.someModulePermission,
  isMaintenanceEnabled: state.home.displayMaintenanceWorkOrders,
  invoiceEnabled: state.home.invoiceEnabled,
  documentEnabled: state.home.documentEnabled,
  leaseDocumentPermission: state.auth?.leaseDocumentPermission,
  avpModulePermission: state.auth?.avpModulePermission,
  trainingEnabled: state.home.trainingEnabled,
  smsSafetyPromEnabled: state.home.smsSafetyPromEnabled,
  isInspectionsEnabled: state.home.isInspectionsEnabled,
  isSharedDcosEnabled: state.home.isSharedDcosEnabled,
  isMyFormsEnabled: state.home.isMyFormsEnabled
});

const mapDispatchToProps = dispatch => ({
  actionFetchProfile: () => {
    dispatch(fetchUserProfile());
  },
  actionCheckModulePermission: (data) => {
    dispatch(checkSomeModulesPermission(data||[]));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(MainLayout);
